import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import SliderComponent from './SliderComponent';
import NewSliderComponent from './NewSliderComponent';
const CardCarousel = props => {
  const $ = _c(35);
  const {
    afterSlideFn,
    beforeSlideFn,
    children,
    className,
    deviceOverride,
    disableSliding,
    fabricGridControls: t0,
    imageHeight,
    imageWidth,
    isMobileMaterialSwatches: t1,
    navType,
    slideIndex,
    variant,
    visibleSlides,
    fullHeight: t2
  } = props;
  const fabricGridControls = t0 === undefined ? false : t0;
  const isMobileMaterialSwatches = t1 === undefined ? false : t1;
  const fullHeight = t2 === undefined ? false : t2;
  let finalVisibleSlides = visibleSlides ? visibleSlides.content ? visibleSlides.content : visibleSlides : 2;
  const {
    isMobile
  } = useScreen();
  if (isMobile && !isMobileMaterialSwatches) {
    finalVisibleSlides = 1;
  }
  const t3 = variant === "reviews-list";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = classNames({
      "[&_.slider-slide]:!min-h-[400px] [&_.slider-slide]:!h-fit [&_.slider-slide]:max-[569px]:!min-h-[275px] [&_.slider-list]:max-[568px]:!overflow-y-scroll": t3,
      className
    });
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== afterSlideFn || $[4] !== beforeSlideFn || $[5] !== children || $[6] !== deviceOverride || $[7] !== disableSliding || $[8] !== fabricGridControls || $[9] !== finalVisibleSlides || $[10] !== fullHeight || $[11] !== imageHeight || $[12] !== imageWidth || $[13] !== isMobileMaterialSwatches || $[14] !== navType || $[15] !== slideIndex || $[16] !== variant) {
    t5 = !isNewConsumerApp && <SliderComponent afterSlideFn={afterSlideFn} beforeSlideFn={beforeSlideFn} deviceOverride={deviceOverride} disableSliding={disableSliding} fabricGridControls={fabricGridControls} finalVisibleSlides={finalVisibleSlides} imageHeight={imageHeight} imageWidth={imageWidth} isMobileMaterialSwatches={isMobileMaterialSwatches} navType={navType} slideIndex={slideIndex} variant={variant} fullHeight={fullHeight}>{children}</SliderComponent>;
    $[3] = afterSlideFn;
    $[4] = beforeSlideFn;
    $[5] = children;
    $[6] = deviceOverride;
    $[7] = disableSliding;
    $[8] = fabricGridControls;
    $[9] = finalVisibleSlides;
    $[10] = fullHeight;
    $[11] = imageHeight;
    $[12] = imageWidth;
    $[13] = isMobileMaterialSwatches;
    $[14] = navType;
    $[15] = slideIndex;
    $[16] = variant;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== afterSlideFn || $[19] !== beforeSlideFn || $[20] !== children || $[21] !== deviceOverride || $[22] !== disableSliding || $[23] !== fabricGridControls || $[24] !== finalVisibleSlides || $[25] !== fullHeight || $[26] !== isMobileMaterialSwatches || $[27] !== navType || $[28] !== slideIndex || $[29] !== variant) {
    t6 = isNewConsumerApp && <NewSliderComponent afterSlideFn={afterSlideFn} beforeSlideFn={beforeSlideFn} deviceOverride={deviceOverride} disableSliding={disableSliding} fabricGridControls={fabricGridControls} finalVisibleSlides={finalVisibleSlides} isMobileMaterialSwatches={isMobileMaterialSwatches} navType={navType} slideIndex={slideIndex} variant={variant} fullHeight={fullHeight}>{children}</NewSliderComponent>;
    $[18] = afterSlideFn;
    $[19] = beforeSlideFn;
    $[20] = children;
    $[21] = deviceOverride;
    $[22] = disableSliding;
    $[23] = fabricGridControls;
    $[24] = finalVisibleSlides;
    $[25] = fullHeight;
    $[26] = isMobileMaterialSwatches;
    $[27] = navType;
    $[28] = slideIndex;
    $[29] = variant;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[31] = t4;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
};
CardCarousel.propTypes = {
  afterSlideFn: PropTypes.func,
  beforeSlideFn: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    url: PropTypes.string,
    value: PropTypes.string
  })),
  deviceOverride: PropTypes.bool,
  disableSliding: PropTypes.bool,
  fabricGridControls: PropTypes.bool,
  imageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMobileMaterialSwatches: PropTypes.bool,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  variant: PropTypes.oneOf(['blog-slider', 'collections-slider', 'material-swatches-sidebar', 'reviews-list']),
  visibleSlides: PropTypes.number,
  fullHeight: PropTypes.bool
};
export default CardCarousel;